module.exports = __webpack_public_path__ + "static/media/pic1.ac5b9f4d.jpg";